import { getToken } from "features/auth/functions/token";
import { ENDPOINT } from "services/axios/constants/endpoints";
import { HTTPMethods } from "services/axios/types/http";
import { getDataFromRequest } from "services/axios/utility/helper";
import { AppThunk } from "services/redux/rootReducer";
import listAllUsers from "./access.listAllUsers";

const removeUser = (params: { uid: string }): AppThunk<Promise<any>> => (
    dispatch
) => {
    return getDataFromRequest(
        ENDPOINT.FUNCTIONS_API.USERS + params.uid,
        HTTPMethods.DELETE,
        getToken()
    ).then((res) => {
        dispatch(listAllUsers());
        return res;
    });
};

export default removeUser;
